<template>
	<v-container fluid class="back">
		<v-row>
			<!-- 工单信息 -->
			<v-col cols="12" md="8" sm="12" xs="12" class="pr-0">
				<v-card elevation="0" class="py-2 px-4">
					<v-card-title class="pa-0">
						<span class="box-title d-inline-block rounded-lg mr-2 v-align-middle"></span><span class="v-align-middle">工单信息</span>
						<v-spacer />
						<a href="#/trade" class="float-right body-2" small outlined>更多<v-icon color="blue">mdi-chevron-double-right</v-icon></a>
					</v-card-title>
					<v-row class="pt-3">
						<v-col md="3" sm="4" xs="4" class="text-center body-2">
							<span>好评指数:</span>
							<v-rating dense background-color="grey lighten-2" color="orange" empty-icon="mdi-checkbox-blank" full-icon="mdi-checkbox-blank" hover length="5" size="24" v-model="trad[0].RN" class="d-inline-block"></v-rating>
							<p class="my-1 grey--text">
								当前 <span class="display-2 orange--text font-weight-bold">{{ trad[0].RN.toFixed(1) }}</span> 级
							</p>
							<p class="grey--text">继续加油哦，还可完善</p>
						</v-col>
						<v-col md="3" sm="3" xs="4">
							<p class="mb-3">工单总量</p>
							<span class="display-1 font-weight-medium">{{ trad[0].TN }}</span
							><br />
							<p class="body-2 my-2 grey--text">
								较去年
								<v-icon size="18" :color="trad[0].TN - trad[1].TN > 0 ? 'red' : 'green'">{{ trad[0].TN - trad[1].TN > 0 ? "mdi-transfer-up" : "mdi-transfer-down" }}</v-icon>
								{{ trad[1].TN > 0 ? ((trad[0].TN - trad[1].TN) / trad[1].TN) * 100 : trad[0].TN * 100 }}%
							</p>
						</v-col>
						<v-col md="3" sm="3" xs="4">
							<p class="mb-3">待办工单</p>
							<span class="display-1 font-weight-medium">{{ trad[0].SN0 }}</span
							><br />
							<p class="body-2 my-2 grey--text">
								较去年<v-icon size="18" :color="trad[0].SN0 - trad[1].SN0 > 0 ? 'red' : 'green'">{{ trad[0].SN0 - trad[1].SN0 > 0 ? "mdi-transfer-up" : "mdi-transfer-down" }}</v-icon>
								{{ trad[1].SN0 > 0 ? ((trad[0].SN0 - trad[1].SN0) / trad[1].SN0) * 100 : trad[0].SN0 * 100 }}%
							</p>
						</v-col>
						<v-col md="3" sm="3" xs="4">
							<p class="mb-3">完结工单</p>
							<span class="display-1 font-weight-medium">{{ trad[0].SN1 }}</span
							><br />
							<p class="body-2 my-2 grey--text">
								较去年
								<v-icon size="18" :color="trad[0].SN1 - trad[1].SN1 > 0 ? 'red' : 'green'">{{ trad[0].SN1 - trad[1].SN1 > 0 ? "mdi-transfer-up" : "mdi-transfer-down" }}</v-icon>
								{{ trad[1].SN1 > 0 ? ((trad[0].SN1 - trad[1].SN1) / trad[1].SN1) * 100 : trad[0].SN1 * 100 }}%
							</p>
						</v-col>
					</v-row>
				</v-card>
			</v-col>
			<!-- 问候语天气 -->
			<v-col cols="12" md="4">
				<v-card elevation="0" class="px-6 py-4 height-100 white--text" :class="$vuetify.theme.dark ? ' grad-blue-dark' : ' grad-blue-2'">
					<span class="title text-overflow-1">您好，{{ user.uniName }}！</span>
					<p class="body-2 mt-1">登录时间：{{ new Date() | date("yyyy-MM-dd HH:mm:ss") }}</p>
					<div class="pt-4">
						<div class="d-inline-block title mr-3">世界会向那些有目标和远见的人让路</div>
						<!-- 
            <div class="d-inline-block display-2 mr-3">31℃</div>
            <div class="d-inline-block">小雨转多云 <br /> <span>XX省/XX市/XX区</span></div>
            -->
						<div class="d-inline-block float-right text-right body-2">
							星期{{ new Date().getDay() | dict("1:一/2:二/3:三/4:四/5:五/6:六/0:日") }} <br />
							<span>{{ new Date() | date("yyyy-MM-dd") }}</span>
						</div>
					</div>
				</v-card>
			</v-col>
			<v-col cols="12" md="8" sm="12" xs="12" class="pr-0 pt-0">
				<!-- 快捷应用 -->
				<v-card elevation="0" class="py-2 px-4" min-height="178">
					<v-card-title class="pa-0">
						<span class="box-title d-inline-block rounded-lg mr-2 v-align-middle"></span><span class="v-align-middle">快捷应用</span>
						<v-spacer />
						<a href="#/serv" class="float-right body-2" small outlined>更多<v-icon color="blue">mdi-chevron-double-right</v-icon></a>
					</v-card-title>
					<v-row v-if="apps" class="pt-4 pb-2">
						<v-col cols="12" md="2" class="text-center" v-for="(item, index) in apps" :key="index">
							<v-btn class="px-0 back_color rounded-lg" @click="toPage(item)" elevation="0" small style="min-height: 60px; min-width: 60px">
								<v-icon size="30" :style="item.pscss">{{ item.props }}</v-icon>
							</v-btn>
							<p class="my-2 body-2 blue-grey--text">{{ item.name }}</p>
						</v-col>
					</v-row>
					<v-sheet v-else class="d-flex" style="height: 120px">
						<span class="ma-auto grey--text">暂无快捷应用</span>
					</v-sheet>
				</v-card>
				<!-- 人员管理 -->
				<v-card elevation="0" class="py-2 px-4 mt-3">
					<v-card-title class="pa-0">
						<span class="box-title d-inline-block rounded-lg mr-2 v-align-middle"></span><span class="v-align-middle">人员信息</span>
						<v-spacer />
						<a href="#/users" class="float-right body-2" small outlined>更多<v-icon color="blue">mdi-chevron-double-right</v-icon></a>
					</v-card-title>
					<div class="d-inline-block mt-4">
						<v-avatar size="56" class="d-inline-block">
							<!-- <v-img src="../../assets/img/user-avatar.png"></v-img> -->
							<v-icon size="60" :color="$vuetify.theme.dark ? '' : 'blue lighten-3'">mdi-account-circle</v-icon>
						</v-avatar>
						<div class="d-inline-block v-align-middle ml-2">
							<p class="mb-0 title">{{ user.citizenName }}</p>
							<span class="grey--text body-2">{{ user.mageIs | dict("0:业务/1:管理") }}</span>
						</div>
						<div>
							<v-avatar size="40" class="my-6"><v-img src="../../assets/img/user-avatar.png"></v-img> </v-avatar>
							<v-avatar size="40" class="my-6 ml-n4"><v-img src="../../assets/img/user-avatar0.png"></v-img> </v-avatar>
							<v-avatar size="40" class="my-6 ml-n4"><v-img src="../../assets/img/user-avatar1.png"></v-img> </v-avatar>
							<v-avatar size="40" class="my-6 ml-n4"><v-img src="../../assets/img/user-avatar0.png"></v-img> </v-avatar>
						</div>
					</div>
					<div class="float-right g-d-sm-none mt-2">
						<v-chip class="ma-2 rounded-lg" :color="$vuetify.theme.dark ? '' : 'blue lighten-5'" text-color="blue" style="height: 120px; width: 90px">
							<div>
								<v-icon class="mt-n8" size="32" color="blue"> mdi-account-supervisor </v-icon>
								<p class="mb-n4 mt-3">
									总人数 <br />
									{{ empe.TN }} 人
								</p>
							</div>
						</v-chip>
						<v-chip class="ma-2 rounded-lg" :color="$vuetify.theme.dark ? '' : 'green lighten-5'" text-color="green" style="height: 120px; width: 90px">
							<div>
								<v-icon class="mt-n8" size="32" color="green"> mdi-account-supervisor </v-icon>
								<p class="mb-n4 mt-3">
									管理 <br />
									{{ empe.AN }} 人
								</p>
							</div>
						</v-chip>
						<v-chip class="ma-2 rounded-lg" :color="$vuetify.theme.dark ? '' : 'cyan lighten-5'" text-color="cyan" style="height: 120px; width: 90px">
							<div>
								<v-icon class="mt-n8" size="32" color="cyan"> mdi-account-supervisor </v-icon>
								<p class="mb-n4 mt-3">
									男性 <br />
									{{ empe.MN }}人
								</p>
							</div>
						</v-chip>
						<v-chip class="ma-2 rounded-lg" :color="$vuetify.theme.dark ? '' : 'pink lighten-5'" text-color="pink" style="height: 120px; width: 90px">
							<div>
								<v-icon class="mt-n8" size="32" color="pink"> mdi-account-supervisor </v-icon>
								<p class="mb-n4 mt-3">
									女性 <br />
									{{ empe.FN }}人
								</p>
							</div>
						</v-chip>
					</div>
				</v-card>
			</v-col>
			<!-- 评价指数 -->
			<v-col cols="12" md="4" class="pt-0">
				<v-card elevation="0" class="height-100">
					<v-card-title class="pt-3"> <span class="box-title d-inline-block rounded-lg mr-2 v-align-middle"></span><span class="v-align-middle">评价指数</span> </v-card-title>
					<v-card-text id="chart1" style="min-height: 340px"></v-card-text>
				</v-card>
			</v-col>
			<!-- 企业信息 -->
			<v-col cols="12" md="12" class="pt-0">
				<v-card elevation="0" class="py-2 px-4" style="min-height: calc(100vh - 705px)">
					<v-card-title class="pt-0 px-0">
						<span class="box-title d-inline-block rounded-lg mr-2 v-align-middle"></span><span class="v-align-middle">单位信息</span>
						<v-spacer />
						<!-- href="#/uams/ente-input" -->
						<a @click="tip" class="float-right body-2" small outlined>去完善<v-icon color="blue">mdi-chevron-double-right</v-icon></a>
					</v-card-title>
					<v-row>
						<v-col cols="12" md="8">
							<v-list-item>
								<v-list-item-avatar size="56">
									<v-icon size="56" :color="$vuetify.theme.dark ? '' : 'blue lighten-3'">mdi-camera-iris</v-icon>
								</v-list-item-avatar>
								<v-list-item-content>
									<v-list-item-title class="title pb-2">{{ user.uniName }}</v-list-item-title>
									<v-list-item-subtitle>{{ user.description }}</v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
							<div class="px-5">
								<v-chip small class="mr-2 mb-2" color="#e0e0e06b" label v-for="(item, index) in role" :key="index"> {{ item.projName }} 资质 </v-chip>
							</div>
						</v-col>
						<v-col cols="12" md="4">
							<v-img src="../../assets/img/back1.png" max-width="400"></v-img>
						</v-col>
					</v-row>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import Request from "@/commons/request";
import Message from "@/components/message";
import Storage from "@/commons/storage";
import toPage from "@/commons/urlstoken";
const echarts = require("echarts");
export default {
	name: "DashHome",
	data() {
		return {
			toPage,
			user: { uniName: "", address: "", description: "" },
			trad: [
				{ RN: 5, SN0: 0, SN2: 0, TN: 0 },
				{ SN0: 0, SN2: 0, TN: 0 },
			],
			empe: {},
			rate: [],
			apps: [],
			role: [],
		};
	},
	mounted() {
		this.user = Storage.get("_wit_acis_users");
		this.home();
	},
	methods: {
		home() {
			Request.postForm("/view/vmain/home").then((res) => {
				this.apps = res.data.apps;
				this.trad = res.data.trad;
				this.empe = res.data.empe;
				this.rate = res.data.rate.map((item) => item.RATE_STAR_BIL);
				this.role = res.data.role;
				this.draw(this.rate);
			});
		},
		draw(rate) {
			let chart1 = echarts.init(document.getElementById("chart1"));
			// 绘制图表
			const option = {
				radar: {
					radius: 130,
					indicator: [
						{ name: "非常满意", max: 1 },
						{ name: "满意", max: 1 },
						{ name: "一般", max: 1 },
						{ name: "不满意", max: 1 },
						{ name: "非常不满意", max: 1 },
					],
				},
				series: [
					{
						name: "满意度评价（Service vs Rating）",
						type: "radar",
						data: [
							{
								value: rate,
								name: "评价详情（Actual Rating）",
							},
						],
					},
				],
			};
			//防止越界，重绘canvas
			window.onresize = chart1.resize;
			chart1.setOption(option);
		},
		tip() {
			Message.toast("应用开发中...", { color: "error" });
		},
	},
};
</script>

<style lang="scss" scoped>
.grad-blue-2 {
	background: url(../../assets/img/back-tq.png) 320px 10px no-repeat, linear-gradient(180deg, #4397fd 0%, #84bcff 100%);
}
.grad-blue-dark {
	background: url(../../assets/img/back-tq.png) 320px 10px no-repeat, linear-gradient(180deg, #1e395c 0%, #3c516b 100%);
}
.back .box-title {
	width: 10px;
	height: 10px;
	background: #eeeeee;
	box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.17);
}
.back .dashed {
	border: 1px #2196f3 dashed;
	background-color: #fff;
}
.theme--light.v-btn.v-btn--has-bg.back_color,
.theme--dark.v-btn.v-btn--has-bg.back_color {
	background-color: #d4d4d444;
}
</style>
